<template>
  <div class="header-top">
    <div class="container">
      <nav class="navigation">
        <ul class="list">
          <li v-for="(item, idx) in headerMenuTop" :key="idx" class="item">
            <AppLink :to="item.url">{{ item.name }}</AppLink>
          </li>
        </ul>
      </nav>

      <HeaderGeolocation />
    </div>
  </div>
</template>

<script setup lang="ts">
  import HeaderGeolocation from './HeaderGeolocation.vue'
  import { AppLink } from '~/components/base-ui/link'
  import { headerMenuTop } from '~/shared/const/menu'
</script>

<style lang="scss" scoped>
  .header-top {
    display: flex;
    align-items: center;
    height: 48px;
    border-bottom: 1px solid $color-figs-10;
    background: $color-default-white;

    @include vp-1439 {
      display: none;
    }

    > .container {
      @include container;

      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    > .container > .navigation > .list {
      @include list-reset;

      display: flex;
      gap: 12px;
    }

    > .container > .navigation > .list > .item {
      > a {
        @extend %font-12;

        display: inline-block;
        color: $color-potato-70;
        white-space: nowrap;
        transition: color $trans-default;

        @include hover-focus {
          cursor: pointer;
          color: $color-kiwi-50;
        }
      }

      > .router-link-active {
        border-bottom: 2px solid $color-kiwi-50;
      }
    }
  }
</style>
